document.addEventListener('DOMContentLoaded', () => {

  const openBtn = document.querySelector('[data-size-guide-open]');
  const closeBtn = document.querySelector('[data-size-guide-close]');
  const drawer = document.querySelector('[data-size-guide-drawer]');
  const overlay = document.querySelector('[data-size-guide-overlay]');

  if (!openBtn) return;

  openBtn.addEventListener('click', () => {
    drawer.classList.add('active');
    overlay.classList.add('active');
  });

  function closeDrawer() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
  }

  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

});